import { Dispatch } from '@/context/cancelBooking'
import { cancelBooking } from '@/lib/cancelBooking'
import CancelBookingConfirm from '@/widgets/CancelBookingConfirm'
import CancelBookingSuccess from '@/widgets/CancelBookingSuccess'
import Modal from '@/widgets/Modal'
import React from 'react'

export interface Props {
  classId?: string
  sessionId?: string
  sessionName?: string
  cancelBookingConfirmPopup: boolean
  toggleCancelBookingConfirmPopup: () => void
  cancelDispatch: Dispatch
}

const CancelBookingPopups = ({
  classId,
  sessionId,
  sessionName,
  cancelBookingConfirmPopup,
  toggleCancelBookingConfirmPopup,
  cancelDispatch,
}: Props): JSX.Element => {
  const [cancelBookingSuccessPopup, setCancelBookingSuccessPopup] = React.useState<boolean>(false)

  const cancelBookingAction = (): void => {
    toggleCancelBookingConfirmPopup()
    cancelDispatch({ type: 'FETCHING', payload: { sessionId } })
    cancelBooking({ classId, sessionId }).then((response) => {
      if (response) {
        cancelDispatch({ type: 'CANCELLED', payload: { sessionId } })
        toggleCancelBookingSuccessPopup()
      } else {
        cancelDispatch({ type: 'FAILED', payload: { sessionId } })
      }
    })
  }

  const toggleCancelBookingSuccessPopup = (): void => {
    setCancelBookingSuccessPopup(!cancelBookingSuccessPopup)
  }

  return (
    <>
      {cancelBookingConfirmPopup ? (
        <Modal onDismiss={toggleCancelBookingConfirmPopup}>
          <CancelBookingConfirm onClickCancel={toggleCancelBookingConfirmPopup} onClickProceed={cancelBookingAction} />
        </Modal>
      ) : null}
      {cancelBookingSuccessPopup ? (
        <Modal onDismiss={toggleCancelBookingSuccessPopup}>
          <CancelBookingSuccess sessionName={sessionName} />
        </Modal>
      ) : null}
    </>
  )
}
export default CancelBookingPopups
